import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const BarChartWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function BarChartWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.06383 1C2.65137 1 3.12766 1.47629 3.12766 2.06383V28.8723H29.9362C30.5237 28.8723 31 29.3486 31 29.9362C31 30.5237 30.5237 31 29.9362 31H2.2766C1.57156 31 1 30.4285 1 29.7234V2.06383C1 1.47629 1.47629 1 2.06383 1Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6808 5.4681C26.2684 5.4681 26.7447 5.94439 26.7447 6.53193V24.8298C26.7447 25.4173 26.2684 25.8936 25.6808 25.8936C25.0933 25.8936 24.617 25.4173 24.617 24.8298V6.53193C24.617 5.94439 25.0933 5.4681 25.6808 5.4681Z"
        fill="#EF145D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5106 16.532C20.0982 16.532 20.5745 17.0082 20.5745 17.5958V24.8298C20.5745 25.4174 20.0982 25.8937 19.5106 25.8937C18.9231 25.8937 18.4468 25.4174 18.4468 24.8298V17.5958C18.4468 17.0082 18.9231 16.532 19.5106 16.532Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3404 13.9787C13.9279 13.9787 14.4042 14.455 14.4042 15.0426L14.4042 24.8298C14.4042 25.4173 13.9279 25.8936 13.3404 25.8936C12.7529 25.8936 12.2766 25.4173 12.2766 24.8298V15.0426C12.2766 14.455 12.7529 13.9787 13.3404 13.9787Z"
        fill="#EF145D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1702 21C7.75774 21 8.23403 21.4763 8.23403 22.0638V24.8298C8.23403 25.4173 7.75774 25.8936 7.1702 25.8936C6.58266 25.8936 6.10637 25.4173 6.10637 24.8298L6.10637 22.0638C6.10637 21.4763 6.58266 21 7.1702 21Z"
        fill="#5137A1"
      />
    </SvgStyled>
  );
});
